//cspell:disable
import React, { useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Header.css";
import "./Nav2.css";

function HeaderNav() {
  const [showCart, setShowCart] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  // Sticky Header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ---------- HEADER ---------- */}
      <div>
        <div className="top-bar">
          <i className="fas fa-less-than" style={{ marginRight: "150px" }}></i>
          <div
            className="marquee"
            style={{ display: "flex", paddingTop: "10px" }}
          >
            <b style={{ fontSize: "14px" }}>Delivery Worldwide</b>{" "}
            <p style={{ fontSize: "13px", paddingTop: "2px" }}>See details</p>
          </div>
          <i className="fas fa-greater-than" style={{ marginLeft: "150px" }}></i>
        </div>

        {/* Navigation */}
        <div className="nav-bar">
          <ul className="nav-links">
            <li>
              <a href="/">WELCOME TO J.</a>
            </li>
            <li>
              <a href="/track">SIGN IN</a> &nbsp;
              <a href="">
                <img style={{ height: "18px" }} src="/flag.png" alt="" />
              </a>
            </li>
            <li>
              <a href="/sign">TRACKING INFO</a>
            </li>
            <li>
              <a href="/corporate">CORPORATE INQUIRY</a>
            </li>
            <li>
              <a href="/create">CREATE AN ACCOUNT</a>
            </li>
            <li>
              <a href="">PKR</a>
            </li>
          </ul>

          {/* Icons */}
          <div className="icons">
            {/* Cart Button */}
            <button style={{ border: "none" }} onClick={() => setShowCart(true)}>
              <i
                className="fa-solid fa-cart-shopping"
                style={{ fontSize: "larger" }}
              ></i>
            </button>

            {/* Cart Offcanvas */}
            <Offcanvas
              show={showCart}
              onHide={() => setShowCart(false)}
              placement="end"
            >
              <Offcanvas.Header
                style={{ backgroundColor: "black", color: "white" }}
              >
                <Offcanvas.Title
                  style={{ fontSize: "14px", paddingLeft: "150px" }}
                >
                  My Bag
                </Offcanvas.Title>
                <button
                  onClick={() => setShowCart(false)}
                  style={{
                    marginLeft: "auto",
                    background: "none",
                    border: "none",
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </Offcanvas.Header>
              <Offcanvas.Body
                style={{
                  textTransform: "uppercase",
                  fontSize: "13px",
                  fontWeight: "bolder",
                  paddingLeft: "50px",
                }}
              >
                You have no items in your shopping Bag.
              </Offcanvas.Body>
            </Offcanvas>

            {/* Search */}
            <button className="search-btn">
              <a href="/fullScreenOverlay">
                <i
                  className="fa-solid fa-magnifying-glass"
                  style={{ fontSize: "14px" }}
                ></i>
                &nbsp; &nbsp;SEARCH
              </a>
            </button>
          </div>
        </div>
      </div>

      {/* ---------- IMAGE STRIP ---------- */}
      <div style={{ margin: "0px", padding: "0px" }}>
        <div
          className="im"
          style={{ width: "100%", height: "70px", backgroundColor: "white" }}
        >
          <div className="imm">
            <img
              style={{ height: "70px", width: "70px" }}
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAdVBMVEX///8jHyAAAAAeGRrx8fFDQUIfGxwHAACxsLC9vLzv7+8bFhc1MjP5+fkXEROLiorZ2NgRCgxVU1THxsbp6elvbW1fXV3Ozc2Bf4CYl5cMAQWgn5/j4uJGQ0Sqqqo5NzdQTU4qJSdraWm4t7cwLS16eHhbWVpOnfiwAAADDElEQVR4nO3c7XKiMBhAYYkCxYiKXxWkW0vV+7/EHSmFBGVXbKfZ1z3PTxhnckaIAWcyGAAAAAAAAAAAAAAAAAAAAAAAKqObuR7pvRbqRi+uR3qvjfZuoheuR3qvkwobmV0VhI/wHUZPhl+JFfgaGZauR/otYmUWDsV+bd1GdqHvejzfj0L5KJSPQvkolI9C+SiUj0L5KJSPQvkolI9C+SiUj0L5KJSPQvkolI9C+SiUj0L5KJSPQvkolI9C+SiUj0L5KJSPQvkolI9C+SiUj0L5KJSPQvkolI9C+SiUj0L5/u/C+Hm5nLsa2LfpLow+9iJKjsIjuwrzhaq2IpqqrcsBfllH4dybNkfDvdg9sQZdhSs9NA8nYneMGnQVvrQ2y1Kp21F+xdXCpfJalNzrdHyt8HSx31m2czzO+10rHLf7PE/vHY/zftcK5+FFYTBxPdC7XSu8vA0p/Je1Cssd6eRepfF4fDHp24Ufm0GO3oKLmeb088Ptbbn237zJaRdbR+3CaVEeLKbtwvCXiyH3Em/UdBh4gVaHZ/O4XZjMyoPPl7/4TgbdR+zXe1wOVWScsAvD6lSRtAKfnIy6j60xeQRq1ZywC1X1LDiaWNepWrsZdQ8r+1o8Nmda92H9gYnxLarCxZj7Se19WINmtrEKp82zbrxWyfkJKtBZImFNureX0knzYsIqVOYkNN/6Osy8fTr++fH2N7F/4MKmxCxsv2mLV3m+GshwW6F6dzjEL2oVJnl9Jm8KBT8htQuDQ3PGWGVbd6E0r1ZhZrx12dUbemeiXxqu7R9wY2nqf75U04fujwtgPfGZE8r880Sg8+6PS2A8D+mNcfxzj/0glHwTnkXGhGIsvHfVcjVQ8neYP9ZLb2MRllbdUy3835fSpk7UaX6eakbRSxWoFlJWLn9W1Bdqpl5PxeJNfUyjSShhZX2TVNW/GUOtdTn3BIk6PsYXWMqLMDH/Uxom6jB7oL6z+cxXKillKvS3y/jvn5Emzt/T2dkuWj1gHgAAAAAAAAAAAAAAAAAAAAAAeFi/ARSII8jKvNn3AAAAAElFTkSuQmCC"
              alt="Logo"
            />
          </div>
        </div>
      </div>

      {/* ---------- NAV2 ---------- */}
      <div className={`second-bar-container ${isSticky ? "sticky" : ""}`}>
        <div className="second-bar d-none d-md-flex">
          <ul
            className="nav-links"
            style={{
              fontFamily: "Alata,sans-serif",
              fontSize: "14px",
              color: "#191919",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              listStyle: "none",
              gap: "55px",
              margin: "0 20px",
            }}
          >
            <Link to="/" style={{ color: "black", textDecoration: "none" }}>
              HOME
            </Link>
            <Link
              to="/new-material"
              style={{ color: "black", textDecoration: "none" }}
            >
              NEW MATERIAL
            </Link>
            <Link
              to="/crew"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <img
                style={{ height: "30px", marginRight: "5px" }}
                src="/crew.png"
                alt=""
              />
            </Link>
            <Link to="/women" style={{ color: "black", textDecoration: "none" }}>
              WOMEN
            </Link>
            <Link to="/men" style={{ color: "black", textDecoration: "none" }}>
              MEN
            </Link>
            <Link to="/bg" style={{ color: "black", textDecoration: "none" }}>
              BOYS & GIRLS
            </Link>
            <Link
              to="/fragrance"
              style={{ color: "black", textDecoration: "none" }}
            >
              FRAGRANCES
            </Link>
            <Link
              to="/makup"
              style={{ color: "black", textDecoration: "none" }}
            >
              MAKEUP
            </Link>
            <Link
              to="/skin"
              style={{ color: "black", textDecoration: "none" }}
            >
              SKINCARE
            </Link>
            <Link
              to="/catu"
              style={{ color: "black", textDecoration: "none" }}
            >
              CATALOGUE
            </Link>
          </ul>
        </div>

        {/* Mobile Menu Button */}
        <div className="d-flex d-md-none" style={{ padding: "10px 20px" }}>
          <button
            style={{
              border: "none",
              background: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={() => setShowMenu(true)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* ---------- MOBILE NAV OFFCANVAS ---------- */}
      <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li><Link to="/" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>HOME</Link></li>
            <li><Link to="/new-material" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>NEW MATERIAL</Link></li>
            <li><Link to="/crew" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>CREW</Link></li>
            <li><Link to="/women" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>WOMEN</Link></li>
            <li><Link to="/men" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>MEN</Link></li>
            <li><Link to="/bg" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>BOYS & GIRLS</Link></li>
            <li><Link to="/fragrance" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>FRAGRANCES</Link></li>
            <li><Link to="/makup" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>MAKEUP</Link></li>
            <li><Link to="/skin" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>SKINCARE</Link></li>
            <li><Link to="/catu" onClick={() => setShowMenu(false)} style={{ color: "inherit", textDecoration: "none" }}>CATALOGUE</Link></li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      {/* ---------- THIRD NAV ---------- */}
      <div className="navbar-third">
        <ul>
          <li>HOME</li>
          <li>CONDITION</li>
        </ul>
      </div>
    </>
  );
}

export default HeaderNav;
